export const FETCH_HL7_RECEIVED_MESSAGES = "[ADMIN] FETCH_HL7_RECEIVED_MESSAGES";
export const FETCH_HL7_RECEIVED_MESSAGES_START = "[ADMIN] FETCH_HL7_RECEIVED_MESSAGES_START";
export const FETCH_HL7_RECEIVED_MESSAGES_SUCCESS = "[ADMIN] FETCH_HL7_RECEIVED_MESSAGES_SUCCESS";
export const FETCH_HL7_RECEIVED_MESSAGES_ERROR = "[ADMIN] FETCH_HL7_RECEIVED_MESSAGES_ERROR";

export const fetchHL7ReceivedMessages = (payload) => {
    return {
        type: FETCH_HL7_RECEIVED_MESSAGES,
        payload
    };
};